import React, { useState } from 'react';
import Modal from "react-modal";
import "./CancelReason.css"
import Error from "../../../assets/lottie/Error.json";
import Lottie from "lottie-react";

const CancelReason = (props) => {


    const { openReasonModal,
        setOpenReasonModal,
        failMessage,
        setFailMessage,
        recallFunctionOnOk,
        recallFunctiononClose,
        meetingName,
        CancelledBy,
        reasonState,
        setReasonState,
        reasonChangeFunction,
        setReason
    } = props;
    const [reasonError, setReasonError] = useState("");

    const closeModal = () => {
        setOpenReasonModal(false);
        recallFunctiononClose();
        setReasonError("");
        setReasonState("");
    }

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };
    const style = {
        width: "34%",
        height: "138px",
        margin: "0 auto"
    }
    const handleValidateInput = (e) => {
        let value;
        if (e.target) {
            value = e?.target?.value;
        }
        else {
            value = e;
        }
        let message;
        if (!value) {
            message = "Reason is required."
        }
        else {
            message = "";
        }
        setReasonError(message);
        return message;
    }
    const handleChangeInput = (e, setReason) => {
        reasonChangeFunction(e, setReason);
        handleValidateInput(e)
    }
    const handleSubmitReason = () => {
        const reasonEr = handleValidateInput(reasonState);
        if (!reasonEr) {
            recallFunctionOnOk();
        }
    }

    const adjustTextareaHeight = () => {
        const element = document.getElementById('cancel-reason')
        element.style.height = 'auto';
        element.style.height = element.scrollHeight + 'px';
    };

    return (
        <div>
            <Modal
                isOpen={openReasonModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div style={{ width: 500, backgroundColor: "white", borderRadius: 10, padding: 15, position: "relative" }}>
                    <div style={{ color: "#00ADEE", padding: "10px 0px", borderBottom: "1px solid #4D4D4F42", fontSize: 18, fontWeight: 500 }}>
                        Meeting Cancellation
                    </div>
                    <div style={{ margin: "10px 0px" }}>
                        <label style={{ fontSize: "15px", fontWeight: '550' }} htmlFor="">Meeting Name</label>
                        <div className='meeting-name-popup' style={{ width: "100%", marginTop: "3px", height: 32, backgroundColor: "#F3F3F3", fontSize: "13px", padding: "4px", display: "flex", alignItems: "center", paddingLeft: 5 }}><span>{meetingName}</span></div>
                    </div>
                    <div style={{ margin: "10px 0px" }}>
                        <label style={{ fontSize: "15px", fontWeight: '550' }} htmlFor="">Cancelled By</label>
                        <div className='meeting-name-popup' style={{ width: "100%", marginTop: "3px", height: 32, backgroundColor: "#F3F3F3", fontSize: "13px", padding: "4px", display: "flex", alignItems: "center", paddingLeft: 5 }}><span>{CancelledBy}</span></div>
                    </div>
                    <div>
                        <label style={{ fontSize: "15px", fontWeight: '550' }} htmlFor="">Cancellation Reason<span style={{ color: "red" }}>*</span></label>
                        <textarea id="cancel-reason" value={reasonState} data-testid='adjustTextareaHeight' onChange={(e) => { adjustTextareaHeight(); handleChangeInput(e, setReason) }} style={{ width: "100%", marginTop: "3px", minHeight: 64, fontSize: "13px", padding: "8px", resize: "none", maxHeight: 190 }}></textarea>
                    </div>
                    {
                        reasonError && <div style={{ width: "100%", textAlign: "left" }} className='form-error'>{reasonError}</div>
                    }
                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <button onClick={() => handleSubmitReason()} style={{ border: "none", width: 80, height: 32, backgroundColor: "#00ADEE", color: "white", borderRadius: 5 }}>Done</button>
                    </div>
                    <div onClick={() => closeModal()} data-testid='closeModal' style={{
                        position: "absolute", width: 25, height: 25, top: 6, right: 8, fontSize: 18, cursor: "pointer", borderRadius: "50%", backgroundColor: "#C2EEFF", display: "flex", justifyContent: "center", alignItems: "center", paddingBottom: 5,
                    }}>
                        <p style={{ color: "#00ADEE" }}>x</p>
                    </div>

                </div>

            </Modal>
        </div>
    )
}

export default CancelReason